import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { logoutAsync } from '../auth/authSlice'
// import { logoutAsync } from '../auth/authSlice'
import { toast } from 'react-toastify'
import './Navbar.css'
import '../branding/brand.css'
import { Images } from '../Assets/Images'
import { BellDot, LogOut } from 'lucide-react';
import { fetchNotifications } from '../Redux/AdminSlices/NotificationSlice';
import { getRoleName, normalizeRoleName, getLoginPathByRole } from '../utils/auth';
import { canAccessAny, getUserPermissionsFromAuth, isAffiliateRole, isStaffRole } from '../utils/userPermissions';
import { PERMISSIONS } from '../utils/permissions';

const formatRoleTitle = (roleName) => {
  const name = normalizeRoleName(roleName);
  if (!name) return 'User';
  return name
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

function Navbar({ onToggleSidebar }) {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const auth = useSelector((state) => state.auth);
  const { role } = auth;
  const userPermissions = getUserPermissionsFromAuth(auth);
  const roleName = getRoleName(role);
  const isAffiliate = isAffiliateRole(role);
  const isStaff = isStaffRole(role);
  const canViewNotifications = canAccessAny(userPermissions, [
    PERMISSIONS.NOTIFICATIONS_VIEW,
    PERMISSIONS.NOTIFICATIONS_CREATE,
    PERMISSIONS.NOTIFICATIONS_SEND,
    PERMISSIONS.PUSH_NOTIFICATIONS,
  ]);
  const { unreadCount } = useSelector((state) => state.notifications || { unreadCount: 0 })

  // Fetch notifications on mount and every 30 minutes
  // useEffect(() => {
  //   if (role?.name === "admin") {
  //     let isMounted = true;

  //     const loadNotifications = async () => {
  //       setIsNotificationsLoading(true);
  //       setNotificationsError('');
  //       try {
  //         await Promise.all([
  //           dispatch(fetchNotifications({ page: 1, pageSize: 20 })),
  //         ]);
  //       } catch (error) {
  //         if (isMounted) {
  //           setNotificationsError('Unable to load notifications.');
  //         }
  //       } finally {
  //         if (isMounted) {
  //           setIsNotificationsLoading(false);
  //         }
  //       }
  //     };

  //     // Fetch immediately on mount
  //     loadNotifications();

  //     // Set up interval to fetch every 30 minutes (1800000 ms)
  //     const interval = setInterval(() => {
  //       loadNotifications();
  //     }, 30 * 60 * 1000); // 30 minutes

  //     // Cleanup interval on unmount
  //     return () => {
  //       isMounted = false;
  //       clearInterval(interval);
  //     };
  //   }
  // }, [dispatch, role?.name]);

  useEffect(() => {
    if (isAffiliate || (isStaff && canViewNotifications)) {
      dispatch(fetchNotifications({ page: 1, pageSize: 20 }));

      const interval = setInterval(() => {
        dispatch(fetchNotifications({ page: 1, pageSize: 20 }));
      }, 30 * 60 * 1000);

      return () => clearInterval(interval);
    }
  }, [dispatch, isAffiliate, isStaff, canViewNotifications]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isModalOpen]);

  const handleProgramTerms = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleLogout = async () => {
    try {
      await dispatch(logoutAsync()).unwrap();

      toast.success('Logged out successfully!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      navigate(getLoginPathByRole(role), { replace: true });
    } catch (error) {
      toast.error(error || 'Logout failed. Please try again.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      navigate(getLoginPathByRole(role), { replace: true });
    }
  };


  return (
    <div className="navbar">
      <div className="navbar-left">
        {/* Mobile Menu Button */}
        <button className="navbar-mobile-menu-button" onClick={onToggleSidebar}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 6H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 18H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <div className="navbar-logo-section">
          <div className="navbar-logo-icon">
            <img src={Images.logo} alt="Logo" style={{ width: '50px', height: '50px', borderRadius: '10px' }} />
          </div>
          {(isAffiliate || isStaff) && (
            <span className="navbar-logo-role">
              {formatRoleTitle(roleName)}
            </span>
          )}
        </div>
        {(isAffiliate || isStaff) && (
          <div className="navbar-title-section">
            <h1 className="navbar-title">{formatRoleTitle(roleName === "affiliate" ? "Team Andy" : roleName)}</h1>
            <p className="navbar-subtitle">
              {isAffiliate
                ? 'Track your referrals and earnings'
                : 'Manage platform operations'}
            </p>
          </div>
        )}
      </div>
      <div className="navbar-right">
        {/* Mobile Menu Button */}
        {/* <button className="navbar-mobile-menu-button" onClick={onToggleSidebar}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 6H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 18H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button> */}

        {isStaff && canViewNotifications && (
          <div className="notification-icon-wrapper" onClick={() => navigate('/admin/notifications')} style={{ marginRight: '16px' }}>
            <BellDot
              style={{ cursor: 'pointer' }}
            />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
            )}
          </div>
        )}

        {isAffiliate &&
          <div className="notification-icon-wrapper" onClick={() => navigate('/notifications')} style={{ marginRight: '16px' }}>
            <BellDot
              style={{ cursor: 'pointer' }}
            />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
            )}
          </div>
        }



        {role?.name === "affiliate" && (
          <button className="navbar-button program-terms-button" onClick={handleProgramTerms}>
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4C4 3.44772 4.44772 3 5 3H10C10.2652 3 10.5196 3.10536 10.7071 3.29289L14.7071 7.29289C14.8946 7.48043 15 7.73478 15 8V16C15 16.5523 14.5523 17 14 17H5C4.44772 17 4 16.5523 4 16V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10 3V8H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M7 12H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M7 15H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <span>Program Terms</span>
          </button>
        )}
        <button className="navbar-button logout-button" onClick={handleLogout}>
          <LogOut className="logout-icon" />
          <span className="logout-text">Logout</span>
        </button>
      </div>

      {/* Program Terms Modal */}
      {isModalOpen && (
        <div className="affiliate-terms-overlay" onClick={handleCloseModal}>
          <div className="affiliate-terms-content" onClick={(e) => e.stopPropagation()}>
            <div className="affiliate-terms-header">
              <div className="affiliate-terms-header-text">
                <h2 className="affiliate-terms-title">Recruiter Program Terms</h2>
                <p className="affiliate-terms-intro">Please read and understand the terms and conditions of the ANDY App Recruiter Program.</p>
              </div>
              <button className="affiliate-terms-close-btn" onClick={handleCloseModal} aria-label="Close modal">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <div className="affiliate-terms-body">
              {/* Credit Terms Section */}
              <div className="affiliate-terms-card affiliate-terms-card-credit">
                <div className="affiliate-terms-card-header">
                  <div className="affiliate-terms-icon affiliate-terms-icon-credit">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5" />
                      <path d="M10 7V10M10 13H10.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </div>
                  <h3 className="affiliate-terms-card-title">Credit Terms</h3>
                </div>
                <ul className="affiliate-terms-list">
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-green"></span>
                    <span><strong>Non-transferable:</strong> Credits are non-transferable and have no cash value. Credits cannot be exchanged, sold, or transferred to another account.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-green"></span>
                    <span><strong>Unlimited Earnings:</strong> Recruiters can earn unlimited referral rewards with no annual cap.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-green"></span>
                    <span><strong>Expiration:</strong> Credits expire <span className="affiliate-terms-highlight">12 months after issuance</span>. Expired credits will be automatically removed from your account.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-green"></span>
                    <span><strong>Automatic Application:</strong> Credits are automatically applied to your next protest filing. No manual redemption is required.</span>
                  </li>
                </ul>
              </div>

              {/* Program Rules Section */}
              <div className="affiliate-terms-card affiliate-terms-card-rules">
                <div className="affiliate-terms-card-header">
                  <div className="affiliate-terms-icon affiliate-terms-icon-rules">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </div>
                  <h3 className="affiliate-terms-card-title">Program Rules</h3>
                </div>
                <ul className="affiliate-terms-list">
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span><strong>Right to Revoke:</strong> ANDY App reserves the right to revoke credits for fraud, abuse, or violation of program terms. This includes but is not limited to: self-referrals, fraudulent referrals, or manipulation of the referral system.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span><strong>Credit Issuance:</strong> Credits are issued when a referred user completes their first eligible action (filing a protest). Credits are processed automatically via Cloud Functions.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span><strong>Badge System:</strong> Badges are awarded based on referral milestones (3, 8, and 15 referrals). Badges are permanent and cannot be revoked except in cases of fraud.</span>
                  </li>
                </ul>
              </div>

              {/* Acceptance of Terms Section */}
              <div className="affiliate-terms-card affiliate-terms-card-acceptance">
                <div className="affiliate-terms-card-header">
                  <div className="affiliate-terms-icon affiliate-terms-icon-acceptance">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                      <path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <h3 className="affiliate-terms-card-title">Acceptance of Terms</h3>
                </div>
                <p className="affiliate-terms-text">By participating in the ANDY App Recruiter Program, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. Participation in the program implies acceptance of all program terms.</p>
              </div>


              <div className="affiliate-terms-card affiliate-terms-card-rules">
                <div className="affiliate-terms-card-header">
                  <div className="affiliate-terms-icon affiliate-terms-icon-rules">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </div>
                  <h3 className="affiliate-terms-card-title">TEXT MESSAGING, CALLS, AND PUSH NOTIFICATIONS</h3>
                </div>
                <ul className="affiliate-terms-list">
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>When you opt in to receive SMS from The Andy App, we collect your mobile phone number and the timestamp of your consent to send service-related messages regarding your property tax appeal and account updates.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>Your phone number and SMS consent information are used only for communication related to our services. We do not sell, rent, share, or transfer your mobile number or SMS opt-in data to any third party for marketing purposes.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>Your SMS consent applies only to The Andy App and does not transfer to any other campaign, brand, or organization.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span><strong>By providing your mobile number and enabling permissions, you consent to receive:</strong></span>
                  </li>
                  <li className="affiliate-terms-list-item" style={{ paddingLeft: '2rem' }}>
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>SMS/Text messages about property tax appeals, including status updates, document requests, and deadline reminders.</span>
                  </li>
                  <li className="affiliate-terms-list-item" style={{ paddingLeft: '2rem' }}>
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>Phone calls from our representatives regarding your property tax appeal.</span>
                  </li>
                  <li className="affiliate-terms-list-item" style={{ paddingLeft: '2rem' }}>
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>Push notifications with updates about appeal status, required actions, and important deadlines.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span><strong>Opt-Out Options:</strong></span>
                  </li>
                  <li className="affiliate-terms-list-item" style={{ paddingLeft: '2rem' }}>
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>Reply STOP to any SMS to opt out of text messages. Your number will be removed from the SMS list within 24 hours.</span>
                  </li>
                  <li className="affiliate-terms-list-item" style={{ paddingLeft: '2rem' }}>
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>You can also change preferences in your account settings or contact customer support to opt out.</span>
                  </li>
                  <li className="affiliate-terms-list-item" style={{ paddingLeft: '2rem' }}>
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>To stop calls, inform our representative or contact customer service.</span>
                  </li>
                  <li className="affiliate-terms-list-item" style={{ paddingLeft: '2rem' }}>
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>Push notifications can be disabled through your device settings.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span><strong>Support:</strong> Reply HELP to any message for assistance or contact our support team through the website's contact details.</span>
                  </li>
                  <li className="affiliate-terms-list-item">
                    <span className="affiliate-terms-bullet affiliate-terms-bullet-orange"></span>
                    <span>Standard message and data rates may apply for SMS messages.</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="affiliate-terms-footer">
              <p className="affiliate-terms-footer-text">
                <strong>Last Updated:</strong> January 5, 2026
              </p>
              <p className="affiliate-terms-footer-text">
                ANDY App reserves the right to modify these terms at any time. Continued participation in the program after changes constitutes acceptance of the modified terms.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Navbar
